import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative bg-[#060A12] border-t border-white/5 px-6 lg:px-10 pt-16 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2 space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-gold-dark to-gold-light flex items-center justify-center text-ink-900 font-display font-bold">SN</div>
            <span className="font-display text-xl text-white">SN Associates</span>
          </div>
          <p className="text-slate-400 text-sm max-w-sm leading-relaxed">
            Trusted accounting, taxation and financial advisory for startups, businesses and professionals across India.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-gold-light font-semibold mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><a href="#services" className="hover:text-white transition-colors">Services</a></li>
            <li><a href="#calculator" className="hover:text-white transition-colors">Tax Calculator</a></li>
            <li><a href="#about" className="hover:text-white transition-colors">About Us</a></li>
            <li><a href="#contact" className="hover:text-white transition-colors">Contact</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-gold-light font-semibold mb-4">Reach Us</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-start gap-2.5"><Mail className="w-4 h-4 text-gold-light mt-0.5" strokeWidth={1.5} /> accohyd768@gmail.com</li>
            <li className="flex items-start gap-2.5"><Phone className="w-4 h-4 text-gold-light mt-0.5" strokeWidth={1.5} /> +91 99127 40286</li>
            <li className="flex items-start gap-2.5"><MapPin className="w-4 h-4 text-gold-light mt-0.5 shrink-0" strokeWidth={1.5} /> Datta Sai Commercial Complex, 2nd Floor, Room 204-A, Block-A, RTC X Roads, Hyderabad 500020</li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
        <p>© {new Date().getFullYear()} SN Associates. All rights reserved.</p>
        <p className="font-mono">Professional Accounting · Tax · Financial Advisory</p>
      </div>
    </footer>
  );
}
